import { Controller } from '@hotwired/stimulus';

import ReturnsGraph, { type DataPoint, type ReturnsGraphOptions } from '../graphs/returns-graph';
import { parseInteger } from '../models/helpers';

export default class extends Controller {
  static targets = ['svg'];

  svgTarget: SVGElement;

  resizeListener: () => void;

  connect() {
    this.draw();
    this.connectResizeListener();
  }

  disconnect() {
    this.disconnectResizeListener();
  }

  draw() {
    const chart = new ReturnsGraph(this.svgTarget, this.graphOptions);
    chart.draw();
  }

  connectResizeListener() {
    this.resizeListener = this.draw.bind(this) as () => void;
    window.addEventListener('resize', this.resizeListener);
  }

  disconnectResizeListener() {
    window.removeEventListener('resize', this.resizeListener);
  }

  get graphOptions(): ReturnsGraphOptions {
    return {
      // @ts-expect-error TS2345 violates strict null checks
      minValue: parseInteger(this.data.get('min-value')),
      // @ts-expect-error TS2345 violates strict null checks
      maxValue: parseInteger(this.data.get('max-value')),
      displayYAxis: Boolean(this.data.get('display-y-axis')),
      // @ts-expect-error TS2345 violates strict null checks
      termYears: parseInteger(this.data.get('term-years')),
      // @ts-expect-error TS2345 violates strict null checks
      valuesByDate: JSON.parse(this.data.get('values-by-date')) as DataPoint[],
    };
  }
}
